module.exports = __webpack_public_path__ + "media/6.a90a300a.mp3";